import { render, staticRenderFns } from "./renxuan1.vue?vue&type=template&id=2ea6de8b&"
import script from "./renxuan1.vue?vue&type=script&lang=js&"
export * from "./renxuan1.vue?vue&type=script&lang=js&"
import style0 from "./renxuan1.vue?vue&type=style&index=0&id=2ea6de8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports